export default __webpack_public_path__ + "0840ee79bee37eacb37d189b9a7e9c99.svg";